/* eslint-disable import/max-dependencies */
import React from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { Grid } from "@mui/material";
import PageInfo from "../../containers/PageInfo";
import FloatingControlButtons from "../../containers/FloatingControlButtons";
import { getPageInfo } from "../../selectors/page";
import { mainBackgroundStyles } from "../../styles/common";
import type { State } from "../AppStoreWrapper";

function PageCreate() {
  const { id: pageId } = useParams<{ id?: string }>();
  const { name } = useSelector((state: State) => getPageInfo(state));

  return (
    <>
      <Helmet>
        <title>{pageId ? `Edit General Info: ${name}` : "Create page"}</title>
      </Helmet>
      <Grid
        container
        direction="column"
        sx={mainBackgroundStyles}
      >
        <Grid>
          <PageInfo />
        </Grid>
      </Grid>
      <Grid>
        <FloatingControlButtons />
      </Grid>
    </>
  );
}

export default PageCreate;
